import get from './get'
import getOne from './get-one'
import getFoundersReport from './get-founders-report'
import getSeoReport from './get-seo-report'
import getMarketCapacityReport from './get-market-capacity-report'
import getMarketResultsReport from './get-market-results-report'
import create from './create'
import getStatistics from './get-statistics'
import getProjectFiles from './get-project-files'
import getProjectMembers from './get-project-members'
import getProjectCase from './get-project-case'
import updateProject from './update-project'
import uploadProjectFile from './upload-project-file'
import getMetrics from './get-metrics'
import createGrowthPointBasics from './create-growth-point-basics'

const services = {
  get,
  create,
  getOne,
  getFoundersReport,
  getSeoReport,
  getMarketCapacityReport,
  getMarketResultsReport,
  updateProject,
  getStatistics,
  getProjectFiles,
  getProjectMembers,
  getProjectCase,
  uploadProjectFile,
  getMetrics,
  createGrowthPointBasics,
}

export default services
